import {InjectionKey} from "vue";
import {FreezeClient} from "@/apis/freeze/FreezeClient";
import {EasClient} from "@/apis/freeze/EasClient";

export const FreezeClientKey = Symbol() as InjectionKey<FreezeClient>
export const EasClientKey = Symbol() as InjectionKey<EasClient>
